var _g, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_912",
    "data-name": "Group 912",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.908,
    height: 16.908,
    viewBox: "0 0 16.908 16.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    fill: "none",
    stroke: "#093549",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.877,
    cy: 6.877,
    r: 6.877,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.877,
    cy: 6.877,
    r: 6.127,
    fill: "none"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    x2: 4.186,
    y2: 4.186,
    transform: "translate(11.661 11.661)",
    fill: "none",
    stroke: "#093549",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconMobile);
export default __webpack_public_path__ + "static/media/search_icon_mobile.593720ed60cb3ee446460e7710fd1ba2.svg";
export { ForwardRef as ReactComponent };